import { Backdrop, CircularProgress, Tooltip } from "@mui/material";
import { Box } from "@mui/system";
import axios from "axios";
import dayjs from "dayjs";
import { useEffect, useReducer, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CustomButton from "../../../CustomComponents/CustomButton";
import DisbursementTabIntegrator from "../Disbursement_Common/DisbursementTabIntegrator";
import { useDispatch, useSelector } from "react-redux";
import PageNotFound from "../../../CustomComponents/PageNotFound";
import NoSpecialAccess from "../../../CustomComponents/NoSpecialAccess";
import { SpecialAccessDetailAction } from "../../../Store/SpecialAccess/SpecialAccessDetailReducer";
import StlapFooter from "../../../CustomComponents/StlapFooter";
import { DisbursementBalanceTransferReducerAction } from "../../../Store/DisbursementBalanceTransfer/DisbursementBalanceTransferReducer";
import { CommonShortCutAction } from "../../../Store/CommonShortCutsReducer";
import store from "../../../Store";
import { DisbursementLosCustomerDataReducerAction } from "../../../Store/DisbursementLosCustomerData/DisbursementLosCustomerDataReducer";

var today = new Date();
var todayDate =
  today.getMonth() + 1 + "/" + today.getDate() + "/" + today.getFullYear();

var disbursementDetailsInitialState = {
  applicationNum: "",
  billingDate: "",
  billDay: "-1",
  dateOfDisb: todayDate,
  disbAmt: 0,
  disbCycleNum: 0,
  transactionKey: 0,
  disbHeaderKey: 0,
  disbursementFavours: [],
  earlierDisbAmt: 0,
  editLock: false,
  effectiveDate: todayDate,
  emiCommDate: "-1",
  firstEmiDueDate: "",
  paymentMode: "RTGS",
  remarks: "",
  approvalRemarks: "",
  requestStatus: "",
  screenMode: "CREATE",
  shflBank: "",
  totalDisbAmt: 0,
  rateOfInterest: 0,
  totalDeductionAmt: 0,
  disbEmiAmt: 0,
  sanctionedEmiAmt: 0,
};

const DisbursementView = (props) => {
  const [billDayValues, setbillDayValues] = useState([]);
  const [deductionTabValue, setdeductionTabValue] = useState({});
  const [pageloading, setPageLoading] = useState(true);
  const [loading, setLoading] = useState(true);
  const [loadingMsg, setLoadingMsg] = useState(
    "Loading Data Please Wait ....."
  );
  const [parameterValues, setparameterValues] = useState({});
  const location = useLocation();
  const navigate = useNavigate();
  const dispatchAction = useDispatch();
  const screenFields = {
    applicationNum: "applicationNum",
    billingDate: "billingDate",
    billDay: "billDay",
    dateOfDisb: "dateOfDisb",
    disbAmt: "disbAmt",
    disbCycleNum: "disbCycleNum",
    transactionKey: "transactionKey",
    disbHeaderKey: "disbHeaderKey",
    disbursementFavours: "disbursementFavours",
    earlierDisbAmt: "earlierDisbAmt",
    editLock: "editLock",
    effectiveDate: "effectiveDate",
    emiCommDate: "emiCommDate",
    firstEmiDueDate: "firstEmiDueDate",
    paymentMode: "paymentMode",
    remarks: "remarks",
    approvalRemarks: "approvalRemarks",
    requestStatus: "requestStatus",
    shflBank: "shflBank",
    totalDisbAmt: "totalDisbAmt",
    transactionId: "transactionId",
    screenMode: "screenMode",
    rateOfInterest: "rateOfInterest",
    totalDeductionAmt: "totalDeductionAmt",
  };

  const reducer = (state, action) => {
    switch (action.type) {
      case screenFields.billingDate:
        return { ...state, billingDate: action.value };
      case screenFields.billDay:
        return { ...state, billDay: action.value };
      case screenFields.dateOfDisb:
        return { ...state, dateOfDisb: action.value };
      case screenFields.disbAmt:
        return { ...state, disbAmt: action.value };
      case screenFields.disbCycleNum:
        return { ...state, disbCycleNum: action.value };
      case screenFields.transactionKey:
        return { ...state, transactionKey: action.value };
      case screenFields.disbursementFavours:
        return { ...state, disbursementFavours: action.value };
      case screenFields.earlierDisbAmt:
        return { ...state, earlierDisbAmt: action.value };
      case screenFields.editLock:
        return { ...state, editLock: action.value };
      case screenFields.effectiveDate:
        return { ...state, effectiveDate: action.value };
      case screenFields.emiCommDate:
        const dateValue = dayjs(action.value).format("MM/DD/YYYY");
        return { ...state, emiCommDate: dateValue };
      case screenFields.firstEmiDueDate:
        return { ...state, firstEmiDueDate: action.value };
      case screenFields.paymentMode:
        return { ...state, paymentMode: action.value };
      case screenFields.remarks:
        return { ...state, remarks: action.value };
      case screenFields.approvalRemarks:
        return { ...state, approvalRemarks: action.value };
      case screenFields.requestStatus:
        return { ...state, requestStatus: action.value };
      case screenFields.shflBank:
        return { ...state, shflBank: action.value };
      case screenFields.totalDisbAmt:
        return { ...state, totalDisbAmt: action.value };
      case screenFields.screenMode:
        return { ...state, screenMode: action.value };
      case screenFields.rateOfInterest:
        return { ...state, rateOfInterest: action.value };
      case screenFields.totalDeductionAmt:
        return { ...state, totalDeductionAmt: action.value };
      case "FullMap":
        return { ...action.value };
      // default:
      //   return { ...disbursementDetailsInitialState };
    }
  };
  /* special Access */
  const programId = useSelector((state) => state.specialAccess.programId);
  const userId = store.getState().branch.userID;
  const modeIdValue = "DB02-V";
  useEffect(() => {
    getModeData();
  }, []);
  const getModeData = async () => {
    const response = await axios.get("/specialAccess/getModeSpecialAccess", {
      method: "get",
      params: {
        userId: userId,
        programId: programId,
        modeId: modeIdValue,
      },
    });
    dispatchAction(SpecialAccessDetailAction.getModeData(response.data));
  };

  const modeAccessMap = useSelector(
    (state) => state.specialAccess.modeAccessMap
  );
  const viewValue = modeAccessMap && modeAccessMap.disbursementView;
  const [disbursementDetailTabValue, dispatch] = useReducer(
    reducer,
    location.state
  );
  const errorParameters = {
    currentDisbError: "currentDisbError",
    roiError: "roiError",
    feddError: "feddError",
    billDayError: "billDayError",
    shflBankError: "shflBankError",
    bankAccountError: "bankAccountError",
    dateOfDisbError: "dateOfDispError",
    overAllError: "overAllError",
    remarksError: "remarksError",
    approvalRemarksError: "approvalRemarksError",
  };

  const errorInitialState = {
    currentDisbError: [false, "Current Disbursement Amount Cannot be Zero."],
    roiError: [false, "Rate of Interest Cannot be Empty/Zero."],
    feddError: [false, "Please Select Billing Date."],
    billDayError: [false, "Please Select Billing Day."],
    shflBankError: [false, "SHFL Bank Cannot be Empty."],
    bankAccountError: [false, "Please Select Atlease One Bank Account."],
    dateOfDisbError: [false, "Please Select Date of Disbursement"],
    overAllError: false,
    approvalRemarksError: [
      false,
      "Please Enter Approval Remarks less than 4000 characters.",
    ],
    remarksError: [false, "Please Enter Remarks less than 4000 characters."],
  };

  const errorReducer = (state, action) => {
    switch (action.type) {
      case errorParameters.currentDisbError:
        return { ...state, currentDisbError: action.value };
      case errorParameters.roiError:
        return { ...state, roiError: action.value };
      case errorParameters.feddError:
        return { ...state, feddError: action.value };
      case errorParameters.billDayError:
        return { ...state, billDayError: action.value };
      case errorParameters.shflBankError:
        return { ...state, shflBankError: action.value };
      case errorParameters.bankAccountError:
        return { ...state, bankAccountError: action.value };
      case errorParameters.dateOfDisbError:
        return { ...state, dateOfDisbError: action.value };
      case errorParameters.overAllError:
        return { ...state, overAllError: action.value };
      case errorParameters.remarksError:
        return { ...state, remarksError: action.value };
      case errorParameters.approvalRemarksError:
        return { ...state, approvalRemarksError: action.value };
      default:
        return { ...errorInitialState };
    }
  };

  const [errorState, errorDispatch] = useReducer(
    errorReducer,
    errorInitialState
  );

  //shortcut key
  const backRef = useRef(null);

  useEffect(() => {
    window.addEventListener("keydown", onKeyUnmountEventHandler);
    window.addEventListener("keyup", onKeyPressEventHandler);
    return () => {
      window.removeEventListener("keydown", onKeyUnmountEventHandler);
      window.removeEventListener("keyup", onKeyPressEventHandler);
    };
  }, []);

  const onKeyPressEventHandler = (event) => {
    let charCode = String.fromCharCode(event.which).toLowerCase();
    let refList = {
      backRef: backRef,
    };
    if (event.ctrlKey) {
      dispatchAction(
        CommonShortCutAction.getShortCutValue({
          event: event,
          refs: refList,
          screen: "disbursementView",
        })
      );
      //}
    }
  };
  const onKeyUnmountEventHandler = (event) => {
    if (event.ctrlKey) {
      dispatchAction(
        CommonShortCutAction.removeDefaultShortCutValue({
          event: event,
          screen: "disbursementCreate",
        })
      );
    }
  };

  useEffect(() => {
    getCustomerDataByAppNum();
    getBillingDayData();
    getDeductionTabData();
    getParameterValues();
    dispatch({
      type: screenFields.screenMode,
      value: props.screenMode,
    });
    setTimeout(() => {
      setPageLoading(false);
      setLoading(false);
      setLoadingMsg("");
    }, 500);
    return () => {
      // on component unmount reset the balance transfer records.
      dispatchAction(
        DisbursementLosCustomerDataReducerAction.resetToInitialState()
      );
      dispatchAction(DisbursementBalanceTransferReducerAction.resetGridRows());
      dispatchAction(
        DisbursementBalanceTransferReducerAction.resetToInitialState()
      );
      dispatchAction(
        DisbursementBalanceTransferReducerAction.updateCurrentRowPaymentMode(
          null
        )
      );
    };
  }, []);

  const getBillingDayData = async () => {
    // const response = await axios.get(
    //   "/disbursement/getAllDisbursementBillingDayData"
    // );
    // Instead of getting values from Disbursement API we should get the values from the LOV MASTER API.
    const disbursementLovValues = await axios.post("/lovMaster/getLovValues", {
      moduleId: "MD001",
    });
    const lovData = disbursementLovValues.data;
    const billDayValues = lovData?.["Billing Day"].map((billDay) => {
      return {
        id: billDay.lovOrder,
        value: billDay.lovValues,
        text: billDay.lovValues,
      };
    });
    setbillDayValues(billDayValues);
  };

  const getCustomerDataByAppNum = async () => {
    const response = await axios.post("/losCustomer/getCustomerDataByAppNum", {
      applicationNum: location.state.applicationNum,
    });
    if (response.status === 200) {
      dispatchAction(
        DisbursementLosCustomerDataReducerAction.setLosCustomerData(
          response.data
        )
      );
    }
  };

  const getDeductionTabData = async () => {
    dispatchAction(
      DisbursementBalanceTransferReducerAction.updateTotalDeductions(0)
    );
    dispatchAction(
      DisbursementBalanceTransferReducerAction.updateTotalDeductionsTabLoadingActive(
        true
      )
    );
    const response = await axios.post("/additionalfee/getFeeData", {
      applicationNum: location.state.applicationNum,
      type: "accrual",
    });
    let paidTotal1 = 0;
    let dueTotal1 = 0;
    let deductionTotal1 = 0;
    let waivedTotal1 = 0;
    let data = {};
    response.data.gridData.map((rows) => {
      data = {};
      paidTotal1 = paidTotal1 + rows.received;
      dueTotal1 = dueTotal1 + rows.receiveable;
      deductionTotal1 =
        deductionTotal1 + (rows.receiveable - rows.received - rows.earlyWaiver);
      waivedTotal1 = waivedTotal1 + rows.earlyWaiver;
    });
    data.paidTotal = paidTotal1;
    data.dueTotal = dueTotal1 - data.paidTotal;
    data.deductionTotal = deductionTotal1;
    data.waivedTotal = waivedTotal1;
    data.accrualTotal = 0;
    data.gridRows = response.data.gridData;
    dispatchAction(
      DisbursementBalanceTransferReducerAction.updateTotalDeductions(
        Number(data.deductionTotal) <= 0 ? 0 : data.deductionTotal
      )
    );
    dispatchAction(
      DisbursementBalanceTransferReducerAction.updateTotalDeductionsTabLoadingActive(
        false
      )
    );
    setdeductionTabValue(data);
  };

  const getParameterValues = async () => {
    const response = await axios.get("/parameter/getAllParameterData");
    const dataMap = {};
    response.data.map((parameter) => {
      dataMap[parameter.paramName] = parameter;
    });
    setparameterValues(dataMap);
  };
  const disbursementViewComponent = <></>;
  return (
    <>
      {loading && (
        <>
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={true}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "8px",
                alignItems: "center",
              }}
            >
              <CircularProgress color="inherit" />
              <p>{loadingMsg}</p>
            </Box>
          </Backdrop>
        </>
      )}
      {!pageloading && (
        <>
          {!viewValue ? (
            <Box style={{ minHeight: "calc(100vh - 120px)" }}>
              <NoSpecialAccess />
            </Box>
          ) : (
            <Box style={{ minHeight: "calc(100vh - 120px)" }}>
              <DisbursementTabIntegrator
                billDayValues={billDayValues}
                deductionTabValue={deductionTabValue}
                setdeductionTabValue={setdeductionTabValue}
                disbursementDetailTabValue={disbursementDetailTabValue}
                screenMode={props.screenMode}
                screenFields={screenFields}
                dispatchEvent={dispatch}
                errorState={errorState}
                screenTitle={props.screenTitle}
                parameterValues={parameterValues}
              />
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  margin: "8px 0px 8px 0px",
                }}
              >
                <Tooltip title="Ctrl+Z" placement="top">
                  <CustomButton
                    sx={{ height: "2rem" }}
                    variant="contained"
                    onClick={() => {
                      if (location.state.fromSancationListPage) {
                        navigate("/stlap/home/disbursementCreatePortal", {
                          replace: true,
                        });
                      } else {
                        if (
                          disbursementDetailTabValue.requestStatus ===
                            "Approved" ||
                          disbursementDetailTabValue.requestStatus ===
                            "Approved , Cheque HandOver Pending" ||
                          disbursementDetailTabValue.requestStatus ===
                            "Approved , Cheque Authourization Pending"
                        ) {
                          navigate("/stlap/home/disbursementApprovalList", {
                            replace: true,
                          });
                        } else if (location.state.screenMode === "CREATE") {
                          navigate("/stlap/home/disbursementCreatePortal", {
                            replace: true,
                          });
                        } else {
                          navigate("/stlap/home/disbursementList", {
                            replace: true,
                          });
                        }
                      }
                    }}
                    ref={backRef}
                  >
                    Back to Search
                  </CustomButton>
                </Tooltip>

                {/* {disbursementDetailTabValue.requestStatus === "Approved" && (
                <CustomButton
                  sx={{
                    height: "2rem",
                    marginLeft: "1%",
                    backgroundColor: "black",
                  }}
                  onMouseOver={({ target }) => {
                    target.style.backgroundColor = "black";
                    target.style.color = "white";
                  }}
                  variant="contained"
                  onClick={() => {
                    const dataValue = { ...disbursementDetailTabValue };
                    dataValue.screenMode = props.screenMode;
                    navigate("/stlap/home/disbursement/repaymentStructure", {
                      replace: true,
                      state: dataValue,
                    });
                  }}
                >
                  Repayment Structure
                </CustomButton>
              )} */}
              </Box>
            </Box>
          )}
          <StlapFooter />
        </>
      )}
    </>
  );
};

export default DisbursementView;
